'use strict';

var _ = require('lodash');
var urlJoin = require('url-join');

var actions = require('./actions');
var requests = require('./requests');
var authenticate = require('./auth/authenticate');
var Csrf = require('./csrf');
var Features = require('./features');
var Partner = require('./partner');
var Preferences = require('./preferences');
var User = require('./user');
var AcceptUserAgreement = require('./accept-user-agreement');
var config = require('./config');

var defaultOptions = config.get();

var addDefaults = (options) => _.merge({}, defaultOptions, options);

var yousers = {
  actions,

  requests,

  csrfInit: (options) => new Csrf(addDefaults(options)),

  features: (options) => new Features(addDefaults(options)),

  partner: (options) => new Partner(addDefaults(options)),

  preferences: (options) => new Preferences(addDefaults(options)),

  user: (options) => new User(addDefaults(options)),

  acceptUserAgreement(options) {
    var user = this.user(options);
    var getUser = user.get.bind(user);

    return new AcceptUserAgreement(getUser, addDefaults(options));
  },

  authenticate(options) {
    var user = this.user(options);
    var getUser = user.get.bind(user);

    return authenticate(getUser, addDefaults(options));
  },

  setAPIRoot(url) {
    config.update('baseUrl', urlJoin(url, '/userservice/'));
    return this;
  },
};

module.exports = yousers;
